import script from "./ShortVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShortVideo.vue?vue&type=script&setup=true&lang=ts"

import "./ShortVideo.vue?vue&type=style&index=0&id=3e625d1e&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@4.5.5__webpack@5.106.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e625d1e"]])

export default __exports__